import fetchDelete from "./fetchDelete";

const deleteUser = async (businessUid, userUid) =>
  fetchDelete(`/${businessUid}/user/${userUid}/delete`);

export default deleteUser;
